import React from 'react';

import { useBlogDispatch } from 'context/BlogContext';

import type { IBlogPageProps } from 'context/BlogContext';

export const useBlogPageProps = (props: IBlogPageProps) => {
  const {
    slug,
    title,
  } = props || {};

  // Hooks

  const { setBlogPageProps, resetBlogPageProps } = useBlogDispatch();

  // Effects

  React.useEffect(() => {
    if (slug && title) {
      setBlogPageProps({ slug, title });
    }
  }, [setBlogPageProps, slug, title]);

  React.useEffect(() => {
    return () => {
      resetBlogPageProps();
    };
  }, [resetBlogPageProps]);

};
